type CornerPosition = "tl" | "tr" | "bl" | "br";

export function CornerBracket({
  position,
  size = 12,
}: {
  position: CornerPosition;
  size?: number;
}) {
  const edges: Record<CornerPosition, string> = {
    tl: "top-[-1px] left-[-1px] border-t-[1.5px] border-l-[1.5px]",
    tr: "top-[-1px] right-[-1px] border-t-[1.5px] border-r-[1.5px]",
    bl: "bottom-[-1px] left-[-1px] border-b-[1.5px] border-l-[1.5px]",
    br: "bottom-[-1px] right-[-1px] border-b-[1.5px] border-r-[1.5px]",
  };
  return (
    <div
      aria-hidden
      className={`pointer-events-none absolute z-20 border-white/20 ${edges[position]}`}
      style={{ width: size, height: size }}
    />
  );
}
